import React, { useState } from 'react';
import propTypes from 'prop-types';
import { Row, Col } from 'antd';
// import Pie from './Graphs/PieChart';
// import VBar from './Graphs/VerticalBarChart';
import GlobalChart from './CRMCharts';
import { Cards } from '../../../components/cards/frame/cards-frame';

const EmailTrack = ({ EmailData, page }) => {
    function formatRate(value) {
        return value % 1 === 0 ? value.toString() : value.toFixed(2);
    }
    // const datasetKeyProvider = () => {
    //     return Math.random().toString();
    // };
    const [paginationState, setPaginationState] = useState({});
    const totalSent = EmailData?.length || 0;
    const bounced = EmailData?.filter?.(e => e?.isMailBounce === "Yes")?.length || 0;
    const deliveredEmails = EmailData?.filter?.(e => e?.isMailBounce !== "Yes") || [];
    const delivered = deliveredEmails.length;
    const opened = deliveredEmails.filter(e =>
        (e.openRates || 0) > 0 || (e.clickedUrls?.length || 0) > 0 || e.isSubscription === "Yes"
    ).length;
    const uniqueClicks = deliveredEmails.filter(e => (e.clickedUrls?.length || 0) > 0).length;
    const unsubscribed = deliveredEmails.filter(e => e.isSubscription === "Yes").length;
    const uniqueReplies = deliveredEmails.filter(e => e.isMailReplyed === "Yes").length;
    const openRateRaw = delivered > 0 ? (opened / delivered) * 100 : 0;
    const bounceRateRaw = totalSent > 0 ? (bounced / totalSent) * 100 : 0;
    const clickRateRaw = delivered > 0 ? (uniqueClicks / delivered) * 100 : 0;
    const unsubscribeRateRaw = delivered > 0 ? (unsubscribed / delivered) * 100 : 0;
    const replyRateRaw = delivered > 0 ? (uniqueReplies / delivered) * 100 : 0;
    const openRate = formatRate(openRateRaw);
    const bounceRate = formatRate(bounceRateRaw);
    const clickRate = formatRate(clickRateRaw);
    const replyRate = formatRate(replyRateRaw);
    const unsubscribeRate = formatRate(unsubscribeRateRaw);

    const unopened = EmailData?.filter?.(e => (e?.openRates || 0) === 0 && (!e?.clickedUrls || e.clickedUrls.length === 0) && e?.isSubscription !== "Yes" && e?.isMailReplyed !== "Yes" && e?.isMailBounce !== "Yes")?.length || 0;

    const sentData = [
        { name: "Opened", value: opened },
        { name: "Delivered", value: unopened },
        { name: "Bounced", value: bounced },
    ];
    const openData = page === "outreach" ? [
        { name: "Clicked", value: uniqueClicks },
        { name: "Reply", value: uniqueReplies },] : [
        { name: "Clicked", value: uniqueClicks },
        { name: "Reply", value: uniqueReplies },
        { name: "Unsubscribed", value: unsubscribed },
    ];
    const COLORS = ["#2f8000", "#9E9E9E", "#ff8000"];
    const COLORS2 = ["#9A3F3F", "#b100ff", "#ff8000",];
    const graph1 = {
        labels: sentData?.map(item => item.name),
        datasets: [{
            data: sentData.map(item => item.value),
            backgroundColor: sentData.map((item, index) => COLORS[index % COLORS.length]),
        }],
    }
    const graph2 = {
        labels: openData?.map(item => item.name),
        datasets: [{
            data: openData.map(item => item.value),
            backgroundColor: openData.map((item, index) => COLORS2[index % COLORS2.length]),
        }],
    }
    return (
        <div>
            <Row gutter={16} style={{ display: "flex", flexWrap: "wrap" }}>
                <Col flex="1" style={{ minWidth: 0 }}>
                    <div className="forecast_TopCard2">
                        <Cards headless bodypadding="10px">
                            <div className="forcast_topBoxes2">
                                <div style={{ textAlign: "center", minWidth: 0 }}>
                                    <div className="Box_centerValue2">{`${openRate}%`}</div>
                                    <div className="Box-Header2">Open Rate</div>
                                </div>
                            </div>
                        </Cards>
                    </div>
                </Col>

                <Col flex="1" style={{ minWidth: 0 }}>
                    <div className="forecast_TopCard2">
                        <Cards headless bodypadding="10px">
                            <div className="forcast_topBoxes2">
                                <div style={{ textAlign: "center", minWidth: 0 }}>
                                    <div className="Box_centerValue2">{`${bounceRate}%`}</div>
                                    <div className="Box-Header2">Bounce Rate</div>
                                </div>
                            </div>
                        </Cards>
                    </div>
                </Col>

                <Col flex="1" style={{ minWidth: 0 }}>
                    <div className="forecast_TopCard2">
                        <Cards headless bodypadding="10px">
                            <div className="forcast_topBoxes2">
                                <div style={{ textAlign: "center", minWidth: 0 }}>
                                    <div className="Box_centerValue2">{`${clickRate}%`}</div>
                                    <div className="Box-Header2">Click Through Rate</div>
                                </div>
                            </div>
                        </Cards>
                    </div>
                </Col>

                <Col flex="1" style={{ minWidth: 0 }}>
                    <div className="forecast_TopCard2">
                        <Cards headless bodypadding="10px">
                            <div className="forcast_topBoxes2">
                                <div style={{ textAlign: "center", minWidth: 0 }}>
                                    <div className="Box_centerValue2">{`${replyRate}%`}</div>
                                    <div className="Box-Header2">Reply Rate</div>
                                </div>
                            </div>
                        </Cards>
                    </div>
                </Col>

                {page !== "outreach" && (
                    <Col flex="1" style={{ minWidth: 0 }}>
                        <div className="forecast_TopCard2">
                            <Cards headless bodypadding="10px">
                                <div className="forcast_topBoxes2">
                                    <div style={{ textAlign: "center", minWidth: 0 }}>
                                        <div className="Box_centerValue2">
                                            {`${unsubscribeRate}%`}
                                        </div>
                                        <div className="Box-Header2">
                                            Unsubscribe Rate
                                        </div>
                                    </div>
                                </div>
                            </Cards>
                        </div>
                    </Col>
                )}
            </Row>
            <Row gutter={16}>
                <Col span={12}>
                    <GlobalChart
                        infoTitle={undefined}
                        pageSize={10}
                        data={{
                            graphId: 10001,
                            graphName: "Email Delivery Performance",
                            graphType: "Pie Chart",
                            currecny: undefined,
                            graphColumnIsCurrency: "NO",
                            graphRowIsCurrecny: "NO",
                            checkbox: "No",
                            chartTypeAdd: "LegendIcon",
                            graphDatas: {
                                labels: graph1.labels,
                                datasets: graph1.datasets,
                                Sumtotal: totalSent,
                                LegendType: "TotalSent",
                            },
                            pageFrom2: "Email"
                        }}
                        graphopenUID={10001}
                        graphDataStandardIndex={10001}
                        setPaginationState={setPaginationState}
                        paginationState={paginationState}
                        COMPAT={undefined}
                        showLegendValues
                        chartHeight={200}
                    />
                    {/* <div className='forecast_TopCard2'>
                        <Cards title="Email Delivery Performance"
                            headStyle={{
                                borderRadius: "20px 20px 0px 0px"
                            }}
                            bodyStyle={{
                                height: "250px",
                                width: "100%",
                            }}>
                            <Row gutter={30} style={{ padding: "10px 0px" }}>
                                <Col xs={14} sm={14} md={14} lg={14} xl={14} xxl={14} >
                                    <div style={{ height: '200px', width: '100%' }}>
                                        <Pie Lables={graph1.labels} Dataset={graph1.datasets} datasetKeyProvider={datasetKeyProvider} height={200} /></div>
                                </Col>
                                <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
                                    <div style={{ textAlign: "center", marginBottom: 30, marginTop: 10 }}>
                                        <div style={{ fontSize: "large", fontWeight: "600" }}>
                                            {totalSent?.toLocaleString()}
                                        </div>
                                        <div style={{ color: "#868eae" }}>
                                            Total Sent
                                        </div>
                                    </div>
                                    {sentData.map((entry, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                marginBottom: "6px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: 12,
                                                    height: 12,
                                                    borderRadius: "50%",
                                                    backgroundColor: COLORS[index % COLORS.length],
                                                    marginRight: 8,
                                                }}
                                            />
                                            <span>
                                                {entry.name} : <strong>{entry.value}</strong>
                                            </span>
                                        </div>
                                    ))}
                                </Col>
                            </Row>
                        </Cards></div> */}
                </Col >
                <Col span={12}>
                    <GlobalChart
                        infoTitle={undefined}
                        pageSize={10}
                        data={{
                            graphId: 10002,
                            graphName: "Email Engagement Analysis",
                            graphType: "Vertical Bar",
                            currecny: undefined,
                            graphColumnIsCurrency: "NO",
                            graphRowIsCurrecny: "NO",
                            checkbox: "No",
                            chartTypeAdd: "LegendIcon",
                            graphDatas: {
                                labels: graph2.labels,
                                datasets: graph2.datasets,
                                Sumtotal: opened,
                                LegendType: "TotalOpened",
                            },
                            pageFrom2: "Email"
                        }}
                        graphopenUID={10002}
                        graphDataStandardIndex={10002}
                        setPaginationState={setPaginationState}
                        paginationState={paginationState}
                        COMPAT={undefined}
                        showLegendValues
                        chartHeight={200}
                    />
                    {/* <div className='forecast_TopCard2'>
                        <Cards title="Email Engagement Analysis"
                            headStyle={{
                                borderRadius: "20px 20px 0px 0px"
                            }}
                            bodyStyle={{
                                height: "250px",
                                width: "100%",
                            }}>
                            <Row gutter={30} style={{ padding: "10px 0px" }}>
                                <Col xs={14} sm={14} md={14} lg={14} xl={14} xxl={14}>
                                    <div style={{ height: '200px', width: '100%' }}>
                                        <VBar Lables={graph2.labels} Dataset={graph2.datasets} datasetKeyProvider={datasetKeyProvider} height={200} /></div>
                                </Col>
                                <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
                                    <div style={{ textAlign: "center", marginBottom: 30, marginTop: 10 }}>
                                        <div style={{ fontSize: "large", fontWeight: "600" }}>
                                            {opened?.toLocaleString()}
                                        </div>
                                        <div style={{ color: "#868eae" }}>
                                            Total Opened
                                        </div>
                                    </div>
                                    {openData.map((entry, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                marginBottom: "6px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: 12,
                                                    height: 12,
                                                    borderRadius: "50%",
                                                    backgroundColor: COLORS2[index % COLORS2.length],
                                                    marginRight: 8,
                                                }}
                                            />
                                            <span>
                                                {entry.name} : <strong>{entry.value}</strong>
                                            </span>
                                        </div>
                                    ))}
                                </Col>
                            </Row>
                        </Cards></div> */}
                </Col>
            </Row >
        </div>
    );
}
EmailTrack.propTypes = {
    EmailData: propTypes.array.isRequired,
    page: propTypes.string.isRequired,
};
export default EmailTrack;